import moment from "moment";

export const MINIMUM_AGE = 13;

export const getMaximumDobByAge = (minimumAge = MINIMUM_AGE) =>
  moment().subtract(minimumAge, "years").endOf("day");

export const createMinimumAgeValidator = (
  minimumAge = MINIMUM_AGE,
  entityLabel = "User",
) => {
  return (_, value) => {
    if (!value) return Promise.resolve();

    if (moment().diff(value, "years") < minimumAge) {
      return Promise.reject(
        new Error(`${entityLabel} must be at least ${minimumAge} years old`),
      );
    }

    return Promise.resolve();
  };
};
